$(document).ready(function(){

  var currentStep = 1 ;
  let newAllProductData = [] ;
  let allProductData = [];
  var block_id ;
  var $nextButton = $('.itg_ctm_footer .itg_ctm_next');


  /*--------------Fillter js----------*/
  
   $(document).on("click", ".itg_ctm_collections_part input", function() {
    var $parentContainer = $(this).closest(".itg_ctm_product_main_pro");
    var checkedValues = [];
    $parentContainer.find(".itg_ctm_collections_part input:checked").each(function() {
        checkedValues.push($(this).val());
    });
  if (checkedValues.length > 0) {
    $parentContainer.find(".itg_ctm_product_main .itg_ctm_product_part").each(function() {
        var checkbox_pro_val = $(this).attr("data-collecton-handle");
        if (checkedValues.includes(checkbox_pro_val)) {
            $(this).css("display", "block");
        } else {
            $(this).css("display", "none");
        }
    });
  } else {
    $parentContainer.find(".itg_ctm_product_main .itg_ctm_product_part").css("display", "inline-block");
  }
});


/*--------------Step js----------*/
  
  $(document).on("click", ".itg_ctm_collection_part", function() {
    currentStep++ ;
    console.log("Step no",currentStep);

    $(this).parents('.itg_steps').removeClass('active');
    $(this).parents('.itg_steps').next().addClass('active');
    $(this).parents('.itg_ctm_section').find('.itg_ctm_footer').addClass('active');
    var a = $(this).parents('.itg_steps').next().attr("id");
    $(".itg_ctm_step ul li").each(function(){
     var b = $(this).attr('data-step');
      if(a == b){
        $(this).addClass('active');
        $(this).removeClass("open_but_not_active");    
      }
    });
    
    block_id = $(this).attr('data-block-id');
    $(this).parents(".itg_steps").next().find('.itg_ctm_product_main_pro').each(function() {
      let pro_block_id = $(this).attr('data-block-id');
      if(pro_block_id == block_id){        
        $(this).addClass('active');
      }else{
        $(this).removeClass('active');}
    });

    addToCartActivate(currentStep);
    
  });

  /*--------------Step remove js----------*/
  
  $(document).on("click", ".itg_ctm_step ul li", function() {

    var stepStr = $(this).attr("data-step") ;
    currentStep = parseInt(stepStr.slice(-1));

    console.log(currentStep) ;

    if(currentStep === 2)
      checkNextButtonStatus() ;
      
    var a = $(this).attr("data-step");
    
    $(".itg_steps").each(function(){
     var b = $(this).attr('id');
      if(a == b){
        $(this).addClass('active');
      }else{
        $(this).removeClass('active');
      }
    });

    if(currentStep > 1  && currentStep <= $(".itg_ctm_section .itg_steps").length )
      $('.itg_ctm_section').find('.itg_ctm_footer').addClass('active');
    else
      $('.itg_ctm_section').find('.itg_ctm_footer').removeClass('active');
    
    if(currentStep > 1 && currentStep < $(".itg_ctm_section .itg_steps").length )
       $('.itg_ctm_next').text("Next") ;
    else
       $('.itg_ctm_next').text("Add to Cart") ;
    
      $(".itg_ctm_step ul li").each(function (index, elem) {
            let temp = ++index ; 
            if($(elem).hasClass("active")){
              if(temp > currentStep )
                $(elem).addClass("open_but_not_active");
              else
                $(elem).removeClass("open_but_not_active");
            }         
      });

    
  }); 


  // footer next button 

 $(document).on("click", ".itg_ctm_footer .itg_ctm_next", function() {

   if(currentStep == 5){
     sendProductsToCartPage();
   }
   if((currentStep+1) > $(".itg_ctm_section .itg_steps").length )
     return ;
   else
      currentStep++ ;

    console.log("step from next" ,currentStep) ;

   if(currentStep == 5){
     $('.itg_ctm_next').text("Add to Cart") ;
   }else
     $('.itg_ctm_next').text("Next") ;
      
    if(currentStep > 1 && currentStep <= $(".itg_ctm_section .itg_steps").length){
      stepToBeShown(currentStep) ;     
    }

   if(currentStep <= $(".itg_ctm_section .itg_steps").length )
      activeHeaderSteps(currentStep);
   
    document.querySelectorAll(".itg_ctm_product_main_pro.active .itg_ctm_product_part input").forEach(function (elem,index) {

        var prodId = elem.closest('.itg_ctm_product_part').getAttribute("data-id") ;
        var prodQty = parseInt(elem.value) ; 
      
        newAllProductData.push({ productId: prodId, quantity: prodQty });
                             
    });
   
   const filteredProductData = cleanProductData(newAllProductData);

   if(currentStep == 5){
     fetchProductsInCstmCart();
   }
  
 });

  // filter product data js

   function cleanProductData(products) {
      const uniqueProducts = {};
      products.forEach(product => {
          if (product.quantity > 0) {
              if (uniqueProducts[product.productId]) {
                  uniqueProducts[product.productId].quantity = product.quantity;
              } else {     
                  uniqueProducts[product.productId] = { ...product };
              }
          }
      });
      return Object.values(uniqueProducts);
  }
    
  // back button functionality
  
 $(document).on("click", ".itg_ctm_footer .itg_ctm_back", function() {
  
   if(currentStep == 5)
     $('.itg_ctm_next').text("Next") ;
    if(currentStep > 0)
      currentStep-- ;

   console.log("step from back" ,currentStep) ;
   
    activeHeaderSteps(currentStep);
    $(".itg_ctm_step ul li").each(function (index, elem) {
      let temp = ++index ;  
      if($(elem).hasClass("active")){
        if(temp > currentStep )
          $(elem).addClass("open_but_not_active");
        else
          $(elem).removeClass("open_but_not_active");
      }
    })
     if(currentStep == 1){
       $(this).parent().removeClass("active");
     }else{
       $(this).parent().addClass("active");
     }
   if(currentStep > 0 && currentStep < $(".itg_ctm_section .itg_steps").length){
     stepToBeShown(currentStep) ;
   }

  
   
 });

  // back button functionality

  function activeHeaderSteps(currentStep){
    
     document.querySelectorAll(".itg_ctm_step ul li").forEach(function (elem,index) {
       let temp = ++index ;
       if(currentStep == temp){
         elem.classList.add("active");
         elem.classList.remove("open_but_not_active");    
       }
     });
  }
  
 function stepToBeShown(currentStep){

   $(".itg_ctm_section .itg_steps").removeClass("active"); 
   document.querySelectorAll(".itg_ctm_section .itg_steps").forEach(function (elem,index) {
     var stepElementIndex = ++index;
     if( currentStep == stepElementIndex){
       elem.classList.add("active");
     }
   });

   $(".container--large .itg_steps.active").find(".itg_ctm_product_main_pro").each(function () {
     let pro_block_id = $(this).attr('data-block-id');
      if(pro_block_id == block_id){        
        $(this).addClass('active');
      }else{
        $(this).removeClass('active');}
   })
   addToCartActivate(currentStep);
 }


  /*--------------Add to Cart js----------*/


function addToCartActivate(currentStep) {
    if (currentStep === 2) {
        disableNextButton();
    }

    $("#step_" + currentStep).find('.itg_ctm_product_part').each(function () {
        const $productContainer = $(this);
        const $addToCartButton = $productContainer.find('.itg_ctm_product_addtocart');
        const $minusButton = $productContainer.find('.itg_ctm_minus');
        const $plusButton = $productContainer.find('.itg_ctm_plus');
        const $quantityInput = $productContainer.find('.input-box');

        // Clear previous event listeners
        $addToCartButton.off("click");
        $minusButton.off("click");
        $plusButton.off("click");
        $quantityInput.off("input");

        $addToCartButton.on("click", function () {
            handleAddToCart($productContainer, $quantityInput);
        });

        $minusButton.on("click", function () {
            handleMinus($productContainer, $quantityInput);
            console.log(allProductData);
        });

        $plusButton.on("click", function () {
            handlePlus($productContainer, $quantityInput);
            console.log(allProductData);
        });

        $quantityInput.on("input", function () {
            handleInput($productContainer, $quantityInput);
            console.log(allProductData);
        });
      
    });
}

function disableNextButton() {
    $nextButton.attr("disabled", true).addClass("not_active");
}

function enableNextButton() {
    $nextButton.removeAttr("disabled").removeClass("not_active");
}

function handleAddToCart($productContainer, $quantityInput) {

    console.log(allProductData, "allProductData");
    const productId = $productContainer.data('id');
    const quantity = parseInt($quantityInput.val()) || 0;

    if (quantity === 0) {
        return;
    }

    $productContainer.addClass("item_active");

    const $addToCartButton = $productContainer.find('.itg_ctm_product_addtocart');
    const existingProductIndex = allProductData.findIndex(product => product.id === productId);

    console.log("product quantity", quantity);

    if (existingProductIndex > -1) {
        allProductData[existingProductIndex].quantity = quantity;
        console.log(allProductData) ;
        $addToCartButton.text('Updated');
    } else {
        $addToCartButton.text('Added');
        allProductData.push({ id: productId, quantity: quantity });
    }

    setTimeout(() => {
        $addToCartButton.text('Add to Cart');
    }, 1500);

    updateProductData($productContainer, quantity);
    checkNextButtonStatus();
}




function handleMinus($productContainer, $quantityInput) {
    console.log("minus btn called");
    let quantity = parseInt($quantityInput.val()) || 0;
    if (quantity > 0) {
        quantity--;
        $quantityInput.val(quantity).attr("value", quantity);

        $productContainer.removeClass("item_active");
        // updateProductData($productContainer, quantity); 
    }
    checkNextButtonStatus();
}

function handlePlus($productContainer, $quantityInput) {
    console.log("plus btn called");
    let quantity = parseInt($quantityInput.val()) || 0;

    // Get the max quantity from the input element's attribute or set a default max
    const maxQuantity = parseInt($quantityInput.attr('max')) || Infinity;

    if (quantity < maxQuantity) {
        quantity++;
        $quantityInput.val(quantity).attr("value", quantity);
        $productContainer.removeClass("item_active");
        // updateProductData($productContainer, quantity);
    } else {
        alert("Maximum quantity reached");
    }

    checkNextButtonStatus();
}

function handleInput($productContainer, $quantityInput) {
    let quantity = parseInt($quantityInput.val()) || 0;

    // Get the max quantity from the input element's attribute or set a default max
    const maxQuantity = parseInt($quantityInput.attr('max')) || Infinity;

    if (isNaN(quantity) || quantity < 0) {
        $quantityInput.val(0);
        quantity = 0;
    } else if (quantity > maxQuantity) {
        alert("Maximum quantity reached");
        $quantityInput.val(maxQuantity).attr("value", maxQuantity);
        quantity = maxQuantity;
    }

    $quantityInput.attr("value", quantity);
    $productContainer.removeClass("item_active");
    // updateProductData($productContainer, quantity);
    checkNextButtonStatus();
}

function updateProductData($productContainer, quantity) {
    const productId = $productContainer.data('id');
    const existingProduct = allProductData.find(product => product.id === productId);

    if (existingProduct) {
        existingProduct.quantity = quantity;
    } else {
        allProductData.push({ id: productId, quantity: quantity });
    }

    allProductData = allProductData.filter(product => product.quantity > 0);
    $productContainer.attr("data-quantity", quantity);

    if ($productContainer.is('[data-deposits]')) {
       console.log('true');
        $productContainer.attr("data-deposits", quantity);
    }

  
}

function checkNextButtonStatus() {
    // Calculate total quantity of active items
    let totalQuantity = 0;
    let waterProdTotQuantity = 0  ;
    $(".itg_ctm_product_part.item_active").each(function () {
        const quantity = parseInt($(this).attr('data-quantity')) || 0;
        console.log($(this),quantity)  ;
        totalQuantity += quantity;
    });

    $(".itg_ctm_product_part.water.item_active").each(function () {
        const waterProdQuantity = parseInt($(this).attr('data-quantity')) || 0;
        console.log($(this),waterProdQuantity)  ;
        waterProdTotQuantity += waterProdQuantity;
    });

    console.log("all products quantity",totalQuantity) ;
    console.log("water products quantity",waterProdTotQuantity) ;

    if(currentStep == 2){
      if (waterProdTotQuantity >= 3) {
          enableNextButton();
      } else {
          disableNextButton();
         
      }
    }
}


  // fetching product details in cart page

     function fetchProductsInCstmCart() {
       console.log("fetchProductsInCstmCart") ;
          $('.all_cart_products_inner').html('');
          $('.equipment_products .equipment_products_inner').html('');
      
          const waterProducts = '.itg_ctm_product_main_pro.active .itg_ctm_product_part.water.item_active';
          const additionalProducts = '.itg_ctm_product_main_pro.active .itg_ctm_product_part.additional_products.item_active';
          const rentalProducts = '.itg_ctm_product_main_pro.active .itg_ctm_product_part.rentals.item_active';

         console.log(waterProducts) ;
      
          addProductsToCart(waterProducts, '.cart_products .all_cart_products_inner');
          addProductsToCart(additionalProducts, '.cart_products .all_cart_products_inner');
          addProductsToCart(rentalProducts, '.equipment_products .equipment_products_inner', true);
      
          document.querySelectorAll('.prod_quantity .quantity_btn button').forEach(function (elem) {
              elem.addEventListener("click", function(event) {
                  handleQuantityChangeCart(event);
              });
          });
      
          document.querySelectorAll('.cart_quantity_input').forEach(function(inputElem) {
              inputElem.addEventListener("input", function(event) {
                  handleQuantityChangeCart(event, true);
              });
          });
      
          function handleQuantityChangeCart(event, isInput = false) {

              const quantityInput = isInput ? event.target : event.target.closest(".prod_quantity").querySelector(".cart_quantity_input");
              const productContainer = quantityInput.closest(".single_cart-product");
              const priceText = productContainer.querySelector(".prod_price h6").textContent.replace('$', '');
              const price = parseFloat(priceText) * 100;
              let currentQuantity = parseInt(quantityInput.value);
      
              if (isNaN(currentQuantity) || currentQuantity < 1) {
                  currentQuantity = 1;
              }
      
              if (!isInput) {
                  if (event.target.classList.contains("increase")) {
                      currentQuantity++;
                  } else if (event.target.classList.contains("decrease") && currentQuantity > 1) {
                      currentQuantity--;
                  }
              }
      
              quantityInput.value = currentQuantity;

              productContainer.setAttribute("data-finQuantity", currentQuantity);

             console.log("plusevent") ;
            
              if (productContainer.hasAttribute('data-deposits')) {
                console.log("attribte") ;
                productContainer.setAttribute("data-deposits", currentQuantity);              
              }

             let totQtyDeposit = 0 ;
             $(".single_cart-product").each(function (index,elem) {
                if($(elem).is('[data-deposits]')){
                  
                 let depositQty = parseInt($(elem).attr("data-deposits"));
                  console.log(depositQty); 
                  
                 if(depositQty != undefined )
                   totQtyDeposit = totQtyDeposit + depositQty ;                
                }
             })

             $('.bottle_deposits_product').attr("data-quantity",totQtyDeposit);

             console.log(totQtyDeposit) ;
             
              const totalCost = (price * currentQuantity) / 100;
              productContainer.querySelector(".prod_total h6").textContent = `$${totalCost.toFixed(2)}`;
          }

           var total_deposits_qty = 0 ;
            
            $('.itg_ctm_product_part.water.item_active').each(function (index,elem) {
                total_deposits_qty = total_deposits_qty + parseInt($(elem).attr("data-quantity")) ; 
            })

            $('.bottle_deposits_product').attr("data-quantity",total_deposits_qty);
            console.log($('.bottle_deposits_product').attr("data-quantity",total_deposits_qty)) ;
            console.log(total_deposits_qty) ;
      }
      
      function addProductsToCart(products, container, isRental = false) {

          $(products).each(function () {
              const quantity = parseInt($(this).attr("data-quantity")) || 0;
              const id = parseInt($(this).attr("data-id"));
              const price = parseInt($(this).attr("data-price"));
              const imgUrl = $(this).attr("data-imgurl");
              const title = $(this).attr("data-title");
              const sellingId = $(this).attr("data-sellingid") ;
              let bottleDeposits = $(this).attr("data-deposits") ;
              console.log(bottleDeposits); 
              // bottleDeposits =  bottleDeposits == undefined ? "" : bottleDeposits ;
              
      
              if (quantity > 0) {
                  if (isRental) {
                      $(container).parent().show();
                  }
      
                  let productHTML = `
                      <div class="single_cart-product" data-product-id="${id}" data-finQuantity=${quantity} 
                      ${bottleDeposits == undefined ? "" : 'data-deposits='+ bottleDeposits }
                      data-sellingId=${sellingId} > 
                          <div class="prod_desc">
                              <div class="prod_img">
                                  <img src="${imgUrl}">
                              </div>
                              <h6 class="prod_title">${title}</h6>
                          </div>
                          <div class="prod_price"><h6>$${price / 100}</h6></div>
                          <div class="prod_quantity">
                            <div class="prod_quantity_input">
                              <div class="quantity_btn minus_btn"><button class="decrease">-</button></div>
                              <input type="number" class="cart_quantity_input" value="${quantity}" min="0" >
                              <div class="quantity_btn plus_btn"><button class="increase">+</button></div>
                            </div>  
                          </div>
                          ${isRental ? '<div class="billing_cycle_rental">Monthly</div>' : ''}
                          <div class="prod_total"><h6>$${(price * quantity) / 100}</h6></div>
                      </div>`;

                  $(container).append(productHTML);
              }
          });
      }


    function sendProductsToCartPage() {
          const productContainers = document.querySelectorAll('.single_cart-product'); 
          const productsData = []; 
          const bottleDepositId = document.querySelector('.bottle_deposits_product').getAttribute("data-id") ;
          const bottleDepositQuantity = document.querySelector('.bottle_deposits_product').getAttribute("data-quantity") ;
      
          productContainers.forEach(container => {
              const productId = container.getAttribute('data-product-id'); 
              const quantity = container.getAttribute('data-finquantity'); 
              let selling_id = container.getAttribute('data-sellingId')  ;
              
              if (productId && quantity) {
                  productsData.push({ 
                      id: productId, 
                      quantity: parseInt(quantity),
                      selling_plan: selling_id, 
                  }); 
              }
          });

          productsData.push({ 
              id: bottleDepositId, 
              quantity: parseInt(bottleDepositQuantity),
              selling_plan: null, 
          });

          if (productsData.length > 0) {
              ajax_AddToCart(productsData, 0); 
          } else {
              console.log('No products to send to the cart.');
          }
      }
      
      function ajax_AddToCart(itemsToAdd, itemIndex) {
          if (itemIndex >= itemsToAdd.length) {        
              location.href = "/cart";
              return;
          }
      
          jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: itemsToAdd[itemIndex],
              dataType: 'json',
              success: function() {
                  itemIndex += 1; 
                  ajax_AddToCart(itemsToAdd, itemIndex);
              },
              error: function(xhr) {
                  console.error('Error adding item to cart:', xhr.responseText);            
              }
          });
      }

  // product info js

   $(".info_icon svg").click(function () {
     $(this).parents('.itg_ctm_product_part').find(".prod_all_information_popup").css("display","flex");
     $(this).parents(".itg_ctm_product_part").find(".product_information").addClass("active");
     $('.itg_ctm_footer').hide();
     $('.itg_ctm_step').hide();
     $("body").addClass("overflow_hidden");
 
   });
  
   $(".cross_popup svg").click(function () {
     $(this).parents('.itg_ctm_product_part').find(".prod_all_information_popup").css("display","none");
     $(this).parents(".itg_ctm_product_part").find(".product_information").removeClass("active");
     $('.itg_ctm_footer').show();
     $('.itg_ctm_step').show();
     $("body").removeClass("overflow_hidden");
   });

  
});
  